import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import API from "../../Services/BaseService";
import { useForm } from "react-hook-form";
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import gasoline from '../../assets/img/gasoline-pump.svg';
import speedometer from '../../assets/img/speedometer.svg';
import cars01 from '../../assets/img/cars01.png';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loading from "../../Component/Loading/Loading";
import InVoice from './InVoice';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import car from '../../assets/img/car.svg';
import GatePassAccept from "../../Container/History/GatePassAccept";
import CarHistory from "../../Container/History/CarHistory";
import Popup from "../../Component/Popup/Popup";
import printJS from 'print-js';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import carcheck from '../../assets/img/carcheck.png';
import barcode from '../../assets/img/barcode.svg';
import Barcode from "react-barcode";
import CommonPopup from '../../Component/CommonPopup/CommonPopup';
import Logo_final from '../../assets/img/Logo_final.png';
import DeliverInfo from './DeliverInfo';
import Datetime from 'react-datetime';
import moment from 'moment';
import wrong from '../../assets/img/wrong.png';
import PageNotFound from '../FallBackUI/PageNotFound';
import DealerAction from '../DealerRedux/DealerAction';
import UrCarAction from '../Carlist/UrCarAction';
import GatePassPrint from './GatePassPrint';
import upload from "../../assets/img/upload.png";
import ls from 'local-storage';
import odometer from '../../assets/img/miles.jpg';
import Pagination from 'reactjs-hooks-pagination';
import _ from 'lodash';
import CustomPagination from '../CustomPagination/CustomPagination';
import * as XLSX from 'exceljs';
import { saveAs } from 'file-saver';
const History = () => {

	const history = useHistory();
	const [loading, setLoading] = useState(true);
	const [historyDetials, setHistoryDetials] = useState([]);
	const successData = useSelector(state => state.LoginReducer.payload);
	const dealerData = useSelector(state => state.DealerReducer.payload);

	const yesterday = moment().subtract(1, 'day');
	const disablePastDt = current => {
		return current.isAfter(scheduleDate);
	};

	console.log("check the history login details", successData);
	const [VINNumber, setVINNumber] = useState("");
	const [year, setYear] = useState("");
	const [make, setMake] = useState("");
	const [model, setModel] = useState("");
	const [dealerList, setDealerList] = useState("");
	const [sellerList, setSellerList] = useState("");
	const [dealerId, setDealerId] = useState("");
	const [selectedSellerDetails, setSelectedSellerDetails] = useState("");
	const [dealername, setDealerName] = useState("");
	const [selectSellerId, setselectSellerid] = useState("");
	console.log("selectSellerId", selectSellerId)
	const [flagFilter, setFalgFilter] = useState(false);
	const dispatch = useDispatch();
	const [deliveryInfo, setDeliveryInfo] = useState("");
	const [vinError, setVinError] = useState("");
	const [paymentstatus, setPaymentStatus] = useState("");
	const [inventoryNo, setInventoryNo] = useState("");
	const [billOfSale, setBillOfSale] = useState("");
	const [titlestatus, setTitleStatus] = useState("");
	const [gatepassstatus, setGatePassStatus] = useState("");
	const [gatepasscode, setGatePassCode] = useState("");
	const [transportationStatus, setTranportationStatus] = useState("");
	const [isShown, setIsShown] = useState(false);
	const [carDetail, setCarDetail] = useState([]);
	const [order, setOrder] = useState("");
	const [copySuccess, setCopySuccess] = useState('');
	const [copied, setCopied] = useState(false);
	const [buttonDisable, setButtonDisable] = useState(false);
	const [carId, setCarId] = useState(null);
	const [billofSaleId, setBillofSaleId] = useState("")
	const [historycarId, setHistoryCarId] = useState(null);
	const [buyerId, setBuyerId] = useState(null);
	const [scheduletodate, setScheduleToDate] = useState("");
	const [scheduleDate, setScheduleDate] = useState("");
	const [fromDateError, setFromDateError] = useState("");
	const [selectAllCar, setSelectAllCar] = useState(false);
	const [mySelectedCarId, setMySelectedCarId] = useState([]);
	// const [searchloadmore,setSearchLoadMore] = useState(false);
	const [historyDetailExcel, setHistoryDetailExcel] = useState([]);
	const [isOpen, setIsOpen] = useState(false);
	const [popupTitle, setPopupTitle] = useState("");
	const [popupMsg, setPopupMsg] = useState("");
	const [popupType, setPopupType] = useState("");
	const [popupActionType, setPopupActionType] = useState("");
	const [popupActionValue, setPopupActionValue] = useState("");
	const [popupActionPath, setPopupActionPath] = useState("")
	const [carDetailsNew, setCarDetailsNew] = useState([]);
	console.log("carDetailsNew", carDetailsNew)
	const [historyDetail, setHistoryDetail] = useState();
	const [isOpenAccept, setIsOpensAccept] = useState(false);
	const [isOpenDeliver, setIsOpensDeliver] = useState(false);
	const [isOpenCarHistory, setIsOpenCarHistory] = useState(false);
	const [loadMore, setLoadMore] = useState(10)
	const [loadMoreOrder, setLoadMoreOrder] = useState(10)
	const [loadMoreSearch, setLoadMoreSearch] = useState(10)
	const [feeDetails, setFeeDetails] = useState("");
	const [historyCount, setHistoryCount] = useState([]);
	const [searchLength, setSearchCarLength] = useState([]);
	const [historySearchCount, setHistorySearchCount] = useState("");
	console.log("historySearchCount", historySearchCount)

	const [searchLoadMore, setSearchLoadMore] = useState(false);
	const [historyDetailsCount, setHistoryDetailsCount] = useState(false)
	const [carDetailLength, setCarDetailLength] = useState("")
	const [transportMode, setTransportMode] = useState("");

	const [isCommonPopupOpen, setIsCommonPopupOpen] = useState(false);

	const [errors, setErrors] = useState("");
	const [errorFlag, setErrorFlag] = useState(false);
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [transCheck, setTransCheck] = useState("");
	const [driverLic, setDriverLic] = useState("");
	const [uploadDriverLic, setUploadDriverLic] = useState("");
	const [transportationName, setTransportationName] = useState("");
	console.log("transCheck", transCheck)
	console.log("transportationName", transportationName)

	const [notes, setNotes] = useState("");
	const [firstNameError, setFirstNameError] = useState("");
	const [lastNameError, setLastNameError] = useState("");
	const [driverLicError, setDriverLicError] = useState("");
	const [carNew, setCarNew] = useState("");
	const [driverDocError, setDriverDocError] = useState("");
	const backUrl = ls.get("backredirection");
	console.log("check the back url", backUrl);
	const back = backUrl[(backUrl.length) - 1];
	console.log("checking the ls.set", backUrl[(backUrl.length) - 1]);


	const [totalRecords, setTotalRecords] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [searchFlag, setSearchFlag] = useState(false);
	const [searchFlag1, setSearchFlag1] = useState(false);
	const [totalPages, setTotalPages] = useState(1);
	console.log(totalPages, "totalPages");
	console.log(totalRecords, "totalReco");
	const pageLimit = 2;

	const handlePages = (page) => {
		ls.set("currentpageopen", page)
		setCurrentPage(page)
		setSearchFlag1(true)
	}

	const handlePageChange = (newPage) => {
		setCurrentPage(newPage);
		setSearchFlag1(true)
	};

	// 	const transportationcheck = (id, item) => {
	// 		if(document.getElementById(id)?.checked){
	// 					setCarDetailsNew(carDetailsNew.map(data => { return { ...data, isChecked: true } }))
	// 		}
	// 	else{
	// 	setCarDetailsNew(carDetailsNew.map(data => { return { ...data, isChecked: false } }))
	// 	}
	// }
	const transportationcheck = (id, item, index) => {

		const newCarDataList = carDetailsNew.map((carData) => {
			if (carData.car_id === item.car_id) {
				if (document.getElementById(id)?.checked) {
					return { ...carData, transaction_check: 1 };
				}
				else {
					document.getElementById(`transportationnameerror${index}`).innerHTML = "";
					return { ...carData, transaction_check: 0 };

				}
			} else {
				return carData;
			}
		});
		setCarDetailsNew(newCarDataList);
	}
	// setTransCheck(document.getElementById(id)?.checked ? 1 :0) 
	// setRecentlyAddedCheckedCars(document.getElementById(id).checked ? [...recentlyAddedcheckedCars, recentlyAddedcarData] : recentlyAddedcheckedCars.filter(data => data.carid !== recentlyAddedcarData.carid))
	// setCheckedCars(carData)


	const inputProps = {
		placeholder: "YYYY-MM-DD",
		value: scheduleDate
	};
	const inputProps1 = {
		placeholder: "YYYY-MM-DD",
		value: scheduletodate
	};
	const fromDate = (event) => {
		console.log("from date", event);

		if (event._isAMomentObject == true) {
			setScheduleDate(event.format("YYYY-MM-DD"))
			setScheduleToDate("")
		}
	}
	const toDate = (event) => {
		console.log("to date", event);
		if (event._isAMomentObject == true) {
			setScheduleToDate(event.format("YYYY-MM-DD"))
		}
	}
	const getFrmDtRemove = () => {
		setScheduleDate("")
		// setScheduleToDate("")
	}
	const getToDtRemove = () => {
		setScheduleToDate("")
	}
	const togglePopup = () => {
		setIsOpen(!isOpen);
	}

	const toggleCommonPopup = () => {
		setIsCommonPopupOpen(!isCommonPopupOpen);
	}

	const togglePopupCarHistory = () => {
		setIsOpenCarHistory(!isOpenCarHistory);
	}
	const togglePopupAccept = () => {
		setIsOpensAccept(!isOpenAccept);
	}
	const togglePopupDeliver = () => {
		setIsOpensDeliver(!isOpenDeliver);
	}
	const gatepassColorChange = () => {
		gethistory(dealerData);
	}

	const gethistory = (data) => {
		//console.log("gethistory=====", data , successData.seller_dealer_id , data.seller_dealer_id);
		let request = {
			seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,
			// seller_dealer_id: data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: successData.seller_dealer_id :data ,
			order: order,
			rowsPerPage: pageLimit,
			page: currentPage,
			seller_id: successData.seller_id,
			seller_token: successData.seller_token,
		}
		console.log("historyDetials", request)
		API.post('historyDetail/condition', request).then(res => {
			if (res.data.success === true) {

				let merged = []

				for (let i = 0; i < res.data.data.length; i++) {
					merged.push({
						...res.data.data[i], ...(res.data.data1.find((item) => item.car_id === res.data.data[i].car_id))
					})
				}
				setCarDetailsNew(merged)
				setTotalPages(Math.ceil(res.data.data3[0].total_count / 2));
				setTotalRecords([...Array(Math.ceil(res.data.data3[0].total_count / 2) + 1).keys()].slice(1))
				setLoadMore(res.data.data.length >= 10 ? res.data.data.length + 10 : loadMore)
				setCarDetailLength(res.data.data.length);

				if (res.data.data.length > 0) {
					setHistoryDetailExcel(res.data.data.map(value => {
						return {
							sellerName: value.sellerName,
							address: value.address,
							seller_state_name: value.seller_state_name,
							seller_city_name: value.seller_city_name,
							seller_zipcode: value.seller_zipcode,
							model: value.model,
							make: value.make,
							year: value.year,
							vin_no: value.vin_no,
							carid: value.carid,
							bill_of_sale_id: value.bill_of_sale_id,
							title_status_name: value.title_status_name,
							gatepasscode: value.gatepasscode
						}
					}))
				}
				setLoading(false);
			}
			else {
				setErrors(res.data.error)
				setErrorFlag(true)
			}
		}).catch(function (error) {
			if (error.response) {
				setErrors(error.response.data.error)
				setErrorFlag(true)
			}
		});
	}

	useEffect(() => {
		if (dealerData !== null) {
			getFilterhistory(dealerData)
		}
	}, [])

	const getFilterhistory = (data, val) => {
		let request = {
			seller_dealer_id: data.seller_dealer_id,
			rowsPerPage: pageLimit,
			page: val == 1 ? 1 : currentPage,
			seller_id: successData.seller_id,
			seller_token: successData.seller_token,
		}
		console.log("historyDetials", request)
		API.post('historyDetailFilter/condition', request).then(res => {
			if (res.data.success === true) {

				let merged = []
				for (let i = 0; i < res.data.data.length; i++) {
					merged.push({
						...res.data.data[i], ...(res.data.data1.find((item) => item.car_id === res.data.data[i].car_id))
					})
				}
				setCarDetailsNew(merged)
				setTotalPages(Math.ceil(res.data.history_count / 2));
				setTotalRecords([...Array(Math.ceil(res.data.history_count / 2) + 1).keys()].slice(1))
				setLoadMore(res.data.data.length >= 10 ? res.data.data.length + 10 : loadMore)
				setCarDetailLength(res.data.data.length);
				if (res.data.data.length > 0) {
					setHistoryDetailExcel(res.data.data.map(value => {
						return {
							sellerName: value.sellerName,
							address: value.address,
							seller_state_name: value.seller_state_name,
							seller_city_name: value.seller_city_name,
							seller_zipcode: value.seller_zipcode,
							model: value.model,
							make: value.make,
							year: value.year,
							vin_no: value.vin_no,
							carid: value.carid,
							bill_of_sale_id: value.bill_of_sale_id,
							title_status_name: value.title_status_name,
							gatepasscode: value.gatepasscode
						}
					}))
				}
				console.log("car Detail", res.data.data);
				// setCarId(res.data.data[0].car_id)
				// setBuyerId(res.data.data[0].buyer_dealer_id)

				setLoading(false);
			}
			else {
				setErrors(res.data.error)
				setErrorFlag(true)
			}
		}).catch(function (error) {
			if (error.response) {
				setErrors(error.response.data.error)
				setErrorFlag(true)
			}
		});
	}

	const handleSellerDetailsName = (e) => {

		setDealerId(e.target.value)
		console.log("=========check seller details name", e.target.value)
		setSelectedSellerDetails(dealerList.filter(data => data.seller_dealer_id == e.target.value)[0])
		console.log("=========check", dealerList.filter(data => data.seller_dealer_id == e.target.value))
		const selectedSellerDetails = dealerList.filter(data => data.seller_dealer_id == e.target.value)[0];
		getFilterhistory(selectedSellerDetails, 1)
		setselectSellerid(selectedSellerDetails.seller_dealer_id)
		setFalgFilter(true)
		dispatch(DealerAction.searchrequest(selectedSellerDetails));

	}

	const getDealername = (data) => {

		let request = {
			seller_id: successData.seller_id,
			seller_token: successData.seller_token,
		}
		API.post("dealerNameDynamic/condition", request).then(response => {
			if (response.data.success === true) {


				setDealerList(response.data.data);

			}

			else {
				setErrors(response.data.error.name)
				setErrorFlag(true)
			}


		})
			.catch(function (error) {
				if (error.response) {
					setErrors(error.response.data.error)
					setErrorFlag(true)
				}
			});
	}


	const historyorder = (data) => {
		let request = {
			seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,
			seller_id: successData.seller_id,
			seller_token: successData.seller_token,
			order: order,
			order: order,
		}
		console.log("history order", request)
		API.post('historyOrder/condition', request).then(res => {
			console.log("history order response", res.data.data);
			if (res.data.success === true) {
				setCarDetail(res.data.data);
				let merged = []


				for (let i = 0; i < res.data.data.length; i++) {
					merged.push({
						...res.data.data[i], ...(res.data.data1.find((item) => item.bill_of_sale_id === res.data.data[i].bill_of_sale_id))
					})
				}
				console.log("merged", merged);
				setCarDetailsNew(merged)
				setTotalPages(Math.ceil(res.data.history_count / 2));
				setTotalRecords([...Array(Math.ceil(res.data.history_count / 2) + 1).keys()].slice(1))
				setHistoryDetail(res.data.data);
				setLoadMoreOrder(res.data.data.length >= 10 ? res.data.data.length + 10 : loadMoreOrder)

			}
			else {
				setErrors(res.data.error)
				setErrorFlag(true)
			}
		}).catch(function (error) {
			if (error.response) {
				setErrors(error.response.data.error)
				setErrorFlag(true)
			}
		});
	}
	function getDocumentType(url) {
		// Extract the file extension
		const extension = url.split('.').pop().toLowerCase();
		console.log("extension", extension)
		return extension;

	}

	const getDeliveryInfo = (item, index) => {
		console.log("document.getElementById(`firstnameerror${index}`).innerHTML", document.getElementById(`firstnameerror${index}`).innerHTML)
		console.log("document.getElementById(`lastnameerror${index}`).innerHTML", document.getElementById(`lastnameerror${index}`).innerHTML)
		console.log("document.getElementById(`driverlicerror${index}`).innerHTML", document.getElementById(`driverlicerror${index}`).innerHTML)
		console.log("document.getElementById(`transportationnameerror${index}`).innerHTML", document.getElementById(`transportationnameerror${index}`).innerHTML)
		console.log("next")
		document.getElementById(`firstnameerror${index}`).innerHTML = "";
		document.getElementById(`lastnameerror${index}`).innerHTML = "";
		document.getElementById(`driverlicerror${index}`).innerHTML = "";
		document.getElementById(`transportationnameerror${index}`).innerHTML = "";

		// setFirstNameError("");
		// setLastNameError("");
		// setDriverLicError();

		if (!firstName) {
			document.getElementById(`firstnameerror${index}`).innerHTML = "FirstName is Required";
			return;
		}
		if (!lastName) {
			// setLastNameError("LastName is Required")
			document.getElementById(`lastnameerror${index}`).innerHTML = "LastName is Required";
			return;
		}
		if (!driverLic) {
			// setDriverLicError("Driver License is Required")
			document.getElementById(`driverlicerror${index}`).innerHTML = "Driver License is Required";
			return;
		}
		console.log("item.transaction_check", item.transaction_check)
		if (item.transaction_check == 1) {
			if (!transportationName) {
				// setLastNameError("LastName is Required")
				document.getElementById(`transportationnameerror${index}`).innerHTML = "Transportation Name is Required";
				return;
			}

		}

		// if (getDocumentType(uploadDriverLic) !== ("pdf"||"docx"||"doc" ||"jpeg" ||"jpg"||"png")) {
		// 	setDriverDocError("Only DOC/DOCX,PDF,JPG,PNG,JPEG file formats can be uploaded")
		// 	return;
		// }

		let request = {
			bill_of_sale_id: item?.bill_of_sale_id,
			car_id: item?.carid,
			first_name: firstName,
			last_name: lastName,
			driver_license: driverLic,
			transaction_check: item.transaction_check ? item.transaction_check : "",
			transportation_name: item.transaction_check == 1 ? transportationName : "",
			notes: notes,
			driver_lic_doc: uploadDriverLic ? [uploadDriverLic] : "",
			// delivery_info: deliveryInfo ? deliveryInfo : item.cardelivery_info,
			// transportation_mode: transportMode ? transportMode : item.transportation_mode,
			seller_id: successData.seller_id,
			seller_token: successData.seller_token,
			updatedBy: successData.seller_id,
			createdBy: successData.seller_id,
		}
		console.log("history order item====", request)
		// return
		API.post('car_delivery_info/add', request).then(response => {
			if (response.data.success) {
				const { data } = response;
				console.log("registration response=>", response)
				toggleCommonPopup()
				setPopupTitle("Delivery Information");
				setPopupMsg("Delivery Information Added Successfully");
				setPopupType("success");
				setPopupActionType("refresh");
				setPopupActionValue("ok");
				gethistory(dealerData);

				// setPopupActionPath("/login")
			} else {
				const { data } = response;
				toggleCommonPopup()
				setPopupTitle("Error");
				setPopupMsg(data.error.err);
				setPopupType("error");
				setPopupActionType("close");
				setPopupActionValue("close");
			}
		})
			.catch(function (error) {
				if (error.response) {
					setErrors(error.response.data.error)
					setErrorFlag(true)
				}
			});
	}

	// const isSelectedAllCar = () => {
	// 	if(selectAllCar) //while chnage funtion is triggering state is not updated so using reverse logic 
	// 	{
	// 		setMySelectedCarId([])
	// 		setHistoryDetail(historyDetail.map(data=> {return {...data, isChecked: false}}))
	// 	}else{
	// 		setMySelectedCarId(historyDetail.map(data=>data.car_id))
	// 		setHistoryDetail(historyDetail.map(data=> {return {...data, isChecked: true}}))
	// 	}

	// 	setSelectAllCar(!selectAllCar)

	//   }


	const numberPattern = (e) => {
		const value = e.target.value.replace(/\D/g, "");
		setYear(value);
	};

	const inventoryNumberPattern = (e) => {
		const value = e.target.value.replace(/\D/g, "");
		setInventoryNo(value);
	};


	const bosNumberPattern = (e) => {
		const value = e.target.value.replace(/\D/g, "");
		setBillOfSale(value);
	};

	const searchCarDetail = (data, value) => {
		setFromDateError("")

		if (scheduletodate) {
			if (!scheduleDate) {
				setFromDateError("From Date is required")
				return;
			}
		}
		if (scheduleDate) {
			if (!scheduletodate) {
				setFromDateError("To Date is required")
				return;
			}
		}
		let request = {
			seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,
			make: make,
			model: model,
			year: year,
			vin_no: VINNumber,
			fromdate: scheduleDate,
			todate: scheduletodate,
			payment_mode: paymentstatus,
			car_id: inventoryNo,
			bill_of_sale_id: billOfSale,
			title_status: titlestatus == "Select" ? "" : titlestatus,
			gatepass_status: gatepassstatus == "Select" ? "" : gatepassstatus,
			gatepass: gatepasscode,
			transportation_status: transportationStatus == "Select" ? "" : transportationStatus,
			rowsPerPage: pageLimit,
			page: value == 1 ? 1 : currentPage,
			seller_id: successData.seller_id,
			seller_token: successData.seller_token,
		}
		console.log("active data", request);
		API.post("historySearch/condition", request)
			.then((res) => {

				if (!make && !model && !year && !VINNumber && !transportationStatus && !gatepassstatus && !titlestatus && !billOfSale && !inventoryNo && !paymentstatus && !scheduletodate && !scheduleDate) {
					setSearchFlag(false)
				}

				if (res.data.success === true) {
					let merged = []

					for (let i = 0; i < res.data.data.length; i++) {
						merged.push({
							...res.data.data[i], ...(res.data.data1.find((item) => item.car_id === res.data.data[i].car_id))
						})
					}
					setHistoryDetailsCount(res.data.data.length)
					setSearchLoadMore(res.data.history_count);
					setCarDetail(res.data.data);


					setCarDetailsNew(merged)
					/* setTotalPages(Math.ceil(res.data.history_count / 2));
					setTotalRecords([...Array(Math.ceil(res.data.history_count / 2) + 1).keys()].slice(1)) */
					setTotalPages(Math.ceil(res.data.data3[0].total_count / 2));
					setTotalRecords([...Array(Math.ceil(res.data.data3[0].total_count / 2) + 1).keys()].slice(1))
					setHistorySearchCount(res.data.data3[0].total_count);
					setLoadMoreSearch(res.data.data.length >= 10 ? res.data.data.length + 10 : loadMoreSearch)

					console.log("search length", res.data.history_count);
					if (res.data.data.length > 0) {
						setHistoryDetailExcel(res.data.data.map(value => {
							return {
								sellerName: value.sellerName,
								address: value.address,
								seller_state_name: value.seller_state_name,
								seller_city_name: value.seller_city_name,
								seller_zipcode: value.seller_zipcode,
								model: value.model,
								make: value.make,
								year: value.year,
								vin_no: value.vin_no,
								carid: value.carid,
								bill_of_sale_id: value.bill_of_sale_id,
								title_status_name: value.title_status_name,
								gatepasscode: value.gatepasscode
								// status:  value.sold							
							}
						}))
					}

				}
				else {
					setErrors(res.data.error)
					setErrorFlag(true)
				}
			}).catch(function (error) {
				if (error.response) {
					setErrors(error.response.data.error)
					setErrorFlag(true)
				}
			});
	}

	const gatePass = (item) => {
		setCarId(item.car_id);
		setBuyerId(item.buyer_dealer_id)
		togglePopupAccept()
	}
	const carDelivery = (item) => {
		setCarId(item.carid);
		setBillofSaleId(item.bill_of_sale_id)
		setCarNew(item)
		togglePopupDeliver()
	}
	const recallDeliver = () => {
		setLoading(true)
		gethistory(dealerData);
	}
	const carhistory = (item) => {
		setHistoryCarId(item.carid);

		togglePopupCarHistory()
	}

	function copytoclipboard(e) {
		document.execCommand('copy');
		e.target.focus();
		setCopySuccess('Copied!');
	};
	function convert(str) {
		var date = new Date(str),
			mnth = ("0" + (date.getMonth() + 1)).slice(-2),
			day = ("0" + date.getDate()).slice(-2);
		return [date.getFullYear(), mnth, day].join("-");
	}
	const handleDateChangeRaw = (e) => {
		e.preventDefault();
	}

	async function fetchBuyerFees(data) {
		console.log("inside fn");
		let request = {
			type: "Seller",
			seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,

			// seller_dealer_id: data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: successData.seller_dealer_id :data ,

			seller_id: successData.seller_id,
			seller_token: successData.seller_token

		};
		const state = API.post('sellerFees/condition', request);
		state.then(res => {
			console.log("res", res)
			if (res.data.success === true) {
				setFeeDetails(res.data.data);
				//  setLoading(false);
			}
			else {
				setErrors(res.data.error)
				setErrorFlag(true)
			}
		}).catch(function (error) {
			if (error.response) {
				setErrors(error.response.data.error)
				setErrorFlag(true)
			}
		});
	}

	const getFeeDetails = (price) => {
		return feeDetails.length > 0 ? feeDetails
			.filter((data) => {
				const range = data.from_price
				const rangeOne = data.to_price

				if (range[1] !== "up") {

					return Number(range) <= Number(price) && Number(price) <= Number(rangeOne)
				}
				else {
					return Number(range) <= Number(price)
				}

			}
			)[0]?.fee || 0
			: 0
	}
	const config = {
		background: "#fff",
		displayValue: false,
		marginTop: "10px",
		marginBottom: "10px",
		fontOptions: "italic",
		width: 2,
		heigth: 5
	};
	const gethistoryLength = (data) => {
		let request = {
			// seller_dealer_id:  successData.seller_dealer_id ,
			seller_dealer_id: data == undefined ? dealerData !== null ? dealerData.seller_dealer_id : successData.seller_dealer_id : data,

			seller_id: successData.seller_id,
			seller_token: successData.seller_token
			// key:10
		}
		console.log("historyCount", request)
		API.post('countDetails/condition', request).then(res => {
			console.log("historyCount response", res.data.data);
			if (res.data.success === true) {
				setHistoryCount(res.data.data);
				console.log("car Detail", res.data.data);

			}
			else {
				setErrors(res.data.error)
				setErrorFlag(true)
			}
		}).catch(function (error) {
			if (error.response) {
				setErrors(error.response.data.error)
				setErrorFlag(true)
			}
		});
	}
	useEffect(() => {
		gethistoryLength();

	}, []);

	useEffect(() => {
		fetchBuyerFees(dealerData);

	}, [dealerData]);

	useEffect(() => {
		order !== "" && historyorder(dealerData);
	}, [order, dealerData]);
	useEffect(() => {
		gethistory(dealerData);
	}, [scheduletodate, scheduleDate, dealerData]);


	useEffect(() => {
		getDealername();

	}, []);

	const togglePrint = () => {
		setIsOpen(!isOpen);
	}


	const PrintData = (item) => {


		setCarId(item.car_id);
		setBillOfSale(item.bill_of_sale_id);
		setYear(item.year);
		setMake(item.make);
		setModel(item.model);
		setVINNumber(item.vin_no);
		setTitleStatus(item.title_status_name);
		setInventoryNo(item.car_id);
		setGatePassCode(item.gatepass_id);




		togglePrint();
	}

	const printPage = (data) => {
		console.log("print")
		printJS({
			printable: "pdfPage",
			type: 'html',
			targetStyles: ['*'],
			header: 'Car Details'
		})
	}

	const showDetails = (data, minusBtn, plusButton) => {
		console.log("showDetails", data)
		document.getElementById(data).setAttribute("class", "showContent");
		document.getElementById(data).removeAttribute("hideContent");

		document.getElementById(minusBtn).removeAttribute("hideContent");
		document.getElementById(minusBtn).setAttribute("class", "bx bx-minus showContent");

		document.getElementById(plusButton).removeAttribute("showContent");
		document.getElementById(plusButton).setAttribute("class", "bx bx-plus hideContent");

	}
	const hideDetails = (data, minusBtn, plusButton) => {
		console.log("hideDetails", data)
		document.getElementById(data).setAttribute("class", "hideContent");
		document.getElementById(data).removeAttribute("showContent");

		document.getElementById(minusBtn).removeAttribute("showContent");
		document.getElementById(minusBtn).setAttribute("class", "bx bx-minus hideContent");

		document.getElementById(plusButton).removeAttribute("hideContent");
		document.getElementById(plusButton).setAttribute("class", "bx bx-plus showContent");

	}

	//   const showBarCode = (barCode,value) =>{
	// 	console.log("showBarCode", barCode, value)
	// 	document.getElementById(barCode).setAttribute("class","showContent",setIsShown(true)); 
	// 	document.getElementById(barCode).removeAttribute( "hideContent");
	//   }

	const showBarCode = (data) => {
		console.log("showBarCode", data)
		document.getElementById(data).setAttribute("class", "showContent");
	}

	const hideBarCode = (data) => {
		console.log("hideBarCode", data)
		document.getElementById(data).setAttribute("class", "hideContent");
	}

	/* const loadMoreDetails = () => {
		if (historyDetailsCount == false) {
			gethistory(dealerData)
		}
		else {
			searchCarDetail(dealerData)
		}
	} */


	const soldredirectpage = (pathid, seller_data, title_status_name, transportation_flag) => {
		dispatch(UrCarAction.sellerid(seller_data))
		history.push({
			pathname: "/soldcardetails",
			state: { backURL: "/history", id: pathid, titlesold: title_status_name, transportationFlag: transportation_flag }
		});
		ls.set("backredirection", [...backUrl, "/history"])
	}

	const redirectGatePass = (pathid) => {
		console.log("redirectGatePass")
		history.push({
			pathname: "/GatePassPrint",
			state: { id: pathid },
		});
	}
	function formatTime(value) {
		let local = ""
		let offset = ""
		local = new Date(value);
		offset = local.getTimezoneOffset();
		value = new Date(local.getTime() - offset * 60000);
		value = moment(value).format('MMMM D, YYYY hh:mm A')
		return value;
	}
	const isValidFile = (file) => {
		let filesArray = Object.values(file);
		let fileExtension = filesArray[0].split('.').pop();

		let isValid = (
			fileExtension == 'doc' ||
			fileExtension == 'docx' ||
			fileExtension == 'pdf' ||
			fileExtension == 'png' ||
			fileExtension == 'jpeg' ||
			fileExtension == 'jpg');
		return isValid;
	}
	const getFiles = (event, index) => {
		document.getElementById(`drivershowerror${index}`).innerHTML = "";

		const file = event.target.files[0];

		if (!file) return;

		const extension = file.name.split(".").pop().toLowerCase();

		const allowed = ["doc", "docx", "pdf", "jpg", "jpeg", "png"];

		if (!allowed.includes(extension)) {
			document.getElementById(`drivershowerror${index}`).innerHTML =
				"Only DOC/DOCX, PDF, JPG, PNG, JPEG file formats can be uploaded";
			return;
		}

		const reader = new FileReader();

		reader.onload = () => {
			const fileData = {
				name: file.name,
				type: file.type,
				size: file.size,
				base64: reader.result.split(",")[1]
			};

			setUploadDriverLic(fileData);

			document.getElementById(`drivershow1${index}`).innerHTML = file.name;
			document
				.getElementById(`drivershow2${index}`)
				.setAttribute("class", "hideContent");
		};

		reader.readAsDataURL(file);
	};
	// const redirecttoInspection = (pathid) => {
	// 	//   history.push("/Inspection/"+pathid);
	// 	history.push({
	// 	  pathname: "/Inspection",
	// 	  state: { id: pathid },
	// 	});
	//   }

	const handleBackButton = () => {

		history.push({
			pathname: back,
			state: { BillofSale: carDetail[0].bill_of_sale_id, CarId: carDetail[0].car_id },
		});
		ls.set("backredirection", backUrl.slice(0, -1))

	}

	const [carSearchTriggered, setCarSearchTriggered] = useState(false);
	console.log("rocords carSearchTriggered", carSearchTriggered, searchFlag1, searchFlag);

	const handlePageChangeDebounced = _.debounce(() => {
		if (!searchFlag1 && !searchFlag) {
			gethistory();
		}
		else if (searchFlag1 && searchFlag && !carSearchTriggered) {
			searchCarDetail();
		} else if (searchFlag1 && !searchFlag) {
			gethistory();
		}
	}, 300);

	useEffect(() => {
		if (searchFlag || searchFlag1) {
			setCarSearchTriggered(false);
		}
	}, [searchFlag, searchFlag1]);




	useEffect(() => {

		handlePageChangeDebounced();
		console.log("checking if in useEffect");
		return () => {
			handlePageChangeDebounced.cancel();
		};

	}, [currentPage]);

	const exportToExcel = async (data) => {
		if (!data || data.length === 0) {
			alert('No data to export');
			return;
		}

		const workbook = new XLSX.Workbook();
		const worksheet = workbook.addWorksheet('URCar');

		// Define columns
		worksheet.columns = [
			{ header: 'Seller Name', key: 'sellerName', width: 20 },
			{ header: 'Address', key: 'address', width: 25 },
			{ header: 'State', key: 'seller_state_name', width: 15 },
			{ header: 'City', key: 'seller_city_name', width: 15 },
			{ header: 'Zipcode', key: 'seller_zipcode', width: 12 },
			{ header: 'Model', key: 'model', width: 15 },
			{ header: 'Make', key: 'make', width: 15 },
			{ header: 'Year', key: 'year', width: 10 },
			{ header: 'VIN #', key: 'vin_no', width: 20 },
			{ header: 'Inventory #', key: 'carid', width: 15 },
			{ header: 'Bill Of Sale #', key: 'bill_of_sale_id', width: 18 },
			{ header: 'Title Status', key: 'title_status_name', width: 15 },
			{ header: 'Gate Pass Code', key: 'gatepasscode', width: 18 }
		];

		// Add data
		data.forEach(item => {
			worksheet.addRow(item);
		});

		// Style header row
		const headerRow = worksheet.getRow(1);
		headerRow.font = { bold: true };
		headerRow.fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFE0E0E0' }
		};

		// Generate Excel file
		const buffer = await workbook.xlsx.writeBuffer();
		const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
		saveAs(blob, `URCar_History_${new Date().toISOString().slice(0, 10)}.xlsx`);
	};
	return (
		<div>

			<main id="main" class="inner-page02">
				{errorFlag === true ? <PageNotFound error={errors} /> :
					<>
						{loading ? <Loading /> :
							<div id="historyPage" class="historyPage titleDuePage">
								<div class="container-fluid inner-page-space" >
									<div class="common-heading">
										<div className="row">
											<div className="col-lg-4">
												<div class="back-btn">
													<a class="back-btn-primary" onClick={() => history.push("/carlist")}>
														<i class="bx bx-chevron-left"></i> Back
													</a>
												</div>
											</div>

											<div className="col-lg-4">
												<div class="title">
													<p class="inner-title">Sold Cars</p>
												</div>
											</div>

											<div className="col-lg-4">
												<div class="downBtn">
													<i class="icofont-file-pdf "></i>
													<button className="" type="button" onClick={() => printPage()}>Download</button>
												</div>

												<div class="downloadBtn">
													<div class="downBtn">
														<i class="icofont-file-excel"></i>
														<button onClick={() => exportToExcel(historyDetailExcel)}>Download Excel</button>
													</div>
												</div>
											</div>
										</div>
									</div>

									<div class="lotfeeblock col-lg-12">

										<div class="row content">
											<div class="col-lg-12 col-md-12 col-sm-12 historyblock toggleList">
												<div class="row" >

													<div class="col-lg-4">
														<p>{carDetailLength} Out Of {historyCount.history_count} vehicles sold</p>
													</div>
													<div className="col-lg-4">
													</div>
													<div className="col-lg-4">
														<div class="title-dropdown">
															<select id="drop" placeholder="" className={`${dealerData != null ? (dealerData?.color == "pink"
																? "tableRowPink  form-control box"
																: dealerData?.color == "firered"
																	? "tableRowFireRed  form-control box"
																	: dealerData?.color == "green"
																		? "tableRowGreenColor form-control box"
																		: dealerData?.color == "darkred"
																			? "tableRowRed1  form-control box"
																			: " form-control box") :
																(dealerList[0]?.color == "pink"
																	? "tableRowPink  form-control box"
																	: dealerList[0]?.color == "firered"
																		? "tableRowFireRed  form-control box"
																		: dealerList[0]?.color == "green"
																			? "tableRowGreenColor form-control box"
																			: dealerList[0]?.color == "darkred"
																				? "tableRowRed1  form-control box"
																				: " form-control box")
																}`} onChange={handleSellerDetailsName}>
																{dealerData != null ?
																	<option value={null} style={{ "display": "none" }}>{dealerData.dealer_name}({dealerData?.seller_dealer_id})</option> :
																	<option value={null} style={{ "display": "none" }}>{dealerList[0]?.dealer_name}({dealerList[0]?.seller_dealer_id})</option>}
																{dealerList.length > 0 &&
																	<>
																		{dealerList.map((dealerList, index) => <option className={dealerList?.color == "pink"
																			? "tableRowPink  user_name"
																			: dealerList?.color == "Silver"
																				? "tableRowSilver  user_name"
																				: dealerList?.color == "Orange"
																					? "tableRowOrange  user_name"
																					: dealerList?.color == "Navy blue"
																						? "tableRowNavyBlue  user_name"
																						: dealerList?.color == "firered"
																							? "tableRowFireRed  user_name"
																							: dealerList?.color == "Purple"
																								? "tableRowPurple  user_name"
																								: dealerList?.color == "Yellow"
																									? "tableRowYellow1  user_name"
																									: dealerList?.color == "green"
																										? "tableRowGreenColor user_name"
																										: dealerList?.color == "blue"
																											? "tableRowBlue  user_name"
																											: dealerList?.color == "darkred"
																												? "tableRowRed1  user_name"
																												: dealerList?.color == "black"
																													? "tableRowBlack1 user_name"
																													: " user_name"} key={dealerList.seller_dealer_id} value={dealerList.seller_dealer_id}  >{dealerList.dealer_name}({dealerList?.seller_dealer_id})</option>)}
																	</>
																}
															</select>
														</div>
													</div>

													<div class="searchlistform col-lg-12">
														<div class="searchblock">
															<div className='row'>
																<div class="form-group col-lg-2">
																	<label class="control-label" for="location">Year</label>
																	<input class="form-control border-end-0" type="text" id="location" placeholder="Enter Car Year" value={year}
																		onChange={numberPattern} />
																</div>

																<div class="form-group col-lg-2">
																	<label class="control-label" for="dealername">Make</label>
																	<input class="form-control border-end-0" type="text" id="dealername" placeholder="Enter Car Make"
																		onChange={(e) => setMake(e.target.value)} />
																</div>

																<div class="form-group col-lg-2">
																	<label class="control-label" for="dealername">Model</label>
																	<input class="form-control border-end-0" type="text" id="dealername" placeholder="Enter Car Model"
																		onChange={(e) => setModel(e.target.value)} />
																</div>

																<div class="form-group col-lg-2 ">
																	<label class="control-label" for="date">Vin #</label>
																	<input class="form-control border-end-0 " type="text" id="date" placeholder="Enter Vin Number"
																		onChange={(e) => setVINNumber(e.target.value)} />

																</div>

																<div class="form-group col-lg-2">
																	<label class="control-label" for="location">Inventory #</label>
																	<input class="form-control border-end-0" type="text" id="location" placeholder="Enter Inventory #"
																		onChange={inventoryNumberPattern} value={inventoryNo} />
																</div>

																<div class="form-group col-lg-2">
																	<label class="control-label" for="bos">BOS #</label>
																	<input class="form-control border-end-0" type="text" id="bos" placeholder="Enter Bos #"
																		onChange={bosNumberPattern} value={billOfSale} />
																</div>

																<div class="form-group col-lg-2">
																	<label class="control-label" for="location">Gate Pass Code</label>
																	<input class="form-control border-end-0" type="text" id="location" placeholder="Enter Gate pass code"
																		onChange={(e) => setGatePassCode(e.target.value)} />
																</div>

																<div className="form-group col-lg-2 dateBlock">
																	<label className="control-label" for="date">From Date</label>
																	<div className="history-date-row">
																		<Datetime closeOnSelect={true} inputProps={inputProps} timeFormat={false} dateFormat="YYYY-MM-DD"
																			name="Date" onChange={fromDate} id="meeting_date1" />
																		{scheduleDate &&
																			<img src={wrong} className="history-date-img" onClick={getFrmDtRemove} />
																		}
																	</div>
																</div>
																<div className="form-group col-lg-2 dateBlock">
																	<label title=" Select From date first to proceed !" className="control-label" for="todate">To Date</label>
																	<div className="history-date-row">
																		<Datetime closeOnSelect={true} inputProps={inputProps1} timeFormat={false} dateFormat="YYYY-MM-DD"
																			name="Date" isValidDate={disablePastDt} onChange={toDate} id="meeting_date2" />
																		{scheduletodate &&
																			<img src={wrong} className="history-date-img" onClick={getToDtRemove} />
																		}
																	</div>
																</div>
																<div class="form-group col-lg-2 carStatus">
																	<label class="control-label" for="dealername">Gate Pass Status</label>
																	<select id="drop" placeholder="Car Status" name="dropoption" className="form-control border-end-0 csSelect"
																		onChange={(e) => setGatePassStatus(e.target.value)}>
																		<option value="Select" >-- Select --</option>
																		<option value="yes">yes</option>
																		<option value="no">no</option>
																	</select>
																</div>
																<div class="form-group col-lg-2 carStatus">
																	<label class="control-label" for="dealername">Title Status</label>
																	<select id="drop" placeholder="Car Status" name="dropoption" className="form-control border-end-0 csSelect"
																		onChange={(e) => setTitleStatus(e.target.value)}>
																		<option value="Select">-- Select --</option>
																		<option value="1">Title with Seller</option>
																		<option value="2">Title with Urs2ndlot</option>
																	</select>
																</div>
																<div class="form-group col-lg-2 carStatus">
																	<label class="control-label" for="location">Transportation Status</label>
																	<select id="drop" placeholder="Car Status" name="dropoption" className="form-control border-end-0 csSelect"
																		onChange={(e) => setTranportationStatus(e.target.value)}>
																		<option value="Select">-- Select --</option>
																		<option value="1">Car with seller</option>
																		<option value="2">In Transit</option>
																		<option value="3">Delivered</option>
																	</select>
																</div>
																<div class=" form-group col-lg-2 searchbtn">
																	<button onClick={() => { searchCarDetail(dealerData, 1); setSearchFlag(true); setCurrentPage(1) }}><i class="bx bx-search"></i></button>
																</div>
															</div>
														</div>
													</div>
													<div class="errorMsgBox col-lg-12">
														<p className="form-input-error" >{vinError}</p>
														<p className="form-input-error" >{fromDateError}</p>
													</div>
												</div>
												<div class="row">
													<div class="col-lg-12 col-md-12 col-sm-12 historyblock p-0">
														<div class="hisHead">
															{historyDetailsCount == "" || historyDetailsCount == null || historyDetailsCount == undefined ? "" :
																<p>{historyDetailsCount}  Out Of {historySearchCount} Vehicles Found</p>}
														</div>

														{carDetailsNew.length > 0 ? carDetailsNew.map((item, index) =>
															<div class="toggleList">
																<div class="lotfee-inner">

																	<div class="">
																		<div class="car-item">
																			<div className="pickupdetailcontent">
																				<p class="billsalesno invNo"><span className="label">Inventory # :</span> {item.carid} </p>
																				<p class="billsalesno model"><span className="label">Year Make Model :</span>{item.year} {item.make} {item.model}</p>
																				<p class="billsalesno vinNo"><span className="label">Vin # :</span>  {item.vin_no}</p>
																				<p class="billsalesno billOf"><span className="label">Bill Of sale # : </span> {item.bill_of_sale_id}</p>
																				<p class="billsalesno netAmt"><span className="label">Net Amount : $</span>  {Number(item.price) - Number((item.bos_seller_fee) + Number(item.bos_car_charges) + Number(item.bos_sellerothertotalcharge) || 0 + Number(item.bos_seller_fee || 0))}</p>
																				<p class="billsalesno soldDate"><span className="label">Seller Name :</span>  {item.sellerName}</p>

																			</div>
																		</div>
																		<div class="toggleIcon plus">
																			<i id={`plusButton${index}`} className='bx bx-plus showContent' onClick={() => showDetails(`showDetails${index}`, `minusButton${index}`, `plusButton${index}`)}></i>

																			<i id={`minusButton${index}`} className="bx bx-minus hideContent " onClick={() => hideDetails(`showDetails${index}`, `minusButton${index}`, `plusButton${index}`)}></i>
																		</div>



																		<div id={`showDetails${index}`} className="hideContent" >
																			<div class="lotfee-inner col-lg-12 toggleExpand">
																				<div class="row">
																					<div class="col-lg-4">
																						<div class="car-item">
																							<div class="cars-prices" >
																								{item.bill_of_sale_id == "" || item.bill_of_sale_id == null ? <a class="cta-btns-primary">Bill Of sale #{item.bill_of_sale_id}</a> :
																									<a class="cta-btns-primary" onClick={() => {
																										history.push({ pathname: "/billofsale", state: { backURL: "/history", BillofSale: item.bill_of_sale_id, CarId: item.car_id } });
																										ls.set("backredirection", [backUrl, "/history"]);
																									}}>Bill Of sale # : {item.bill_of_sale_id}</a>}
																								<p class="car-btns"> Inventory # : {/* class="billsalesno pull-right enableBtn" */} <span class='hyperlink' onClick={() => { soldredirectpage(item.carid, item, item.title_status_name, item.transportation_flag) }}> {item.carid}</span></p>
																							</div>
																							<div className="historyImg">
																								<img src={item.image} onClick={() => { soldredirectpage(item.carid, item, item.title_status_name, item.transportation_flag) }} class="carImg" alt="..." />
																							</div>
																						</div>
																					</div>


																					<div className='col-lg-4'>
																						<div class="cars-content">
																							<p class="soldDate"><span><span className="label">Sold Date : </span>{formatTime(item.sold_date)}</span></p>
																							<h3>
																								<a href="#"> {item.year} {item.make} {item.model}</a>
																							</h3>
																							<div class="km-petrol">
																								<p class="details"><img src={speedometer} alt="" /><span>{item.mileage} {item.mileage_type}</span></p>
																								<p class="details">{item.fuel_type ? <img src={gasoline} alt="" /> : ""}<span>{item.fuel_type === "null" || item.fuel_type === "undefined" || item.fuel_type === null || item.fuel_type === undefined || item.fuel_type === "" ? "" : item.fuel_type}</span></p>
																							</div>


																							<div class="vinqr">
																								<div class="carpoints">
																									<div className="label">VIN #</div>
																									<div class="carpoint">
																										<img src={car} alt="" />
																										<span>{item.vin_no}</span>
																										<CopyToClipboard text={item.vin_no} onCopy={() => setCopied(true)} >
																											<span title="Copy" onClick={copytoclipboard} className="copyImg"><i class="icofont-copy"></i></span>
																										</CopyToClipboard>
																										<img id={`imgBarCode${index}`} src={barcode} alt="" onMouseEnter={() => document.getElementById(`showBarCodeDetails${index}`).setAttribute("class", "showContent qrcode")} onMouseLeave={() => document.getElementById(`showBarCodeDetails${index}`).setAttribute("class", "hideContent")} />
																									</div>
																								</div>
																								<div id={`showBarCodeDetails${index}`} className="hideContent" >
																									<Barcode value={item.vin_no} {...config} />
																								</div>
																							</div>

																							<div class="title-status">
																								<p className="title-label">Title status :<span className='tit-status1'></span>
																									<div className={`${item?.title === "Title" ? "title-cart" : item?.title === "Title Attached" ? "titleattached-cart" : item?.title === "Bill of sale only" ? "billofsale-cart" : ""}`}>{item?.title}
																									</div>
																								</p>
																							</div>


																							<div className='insp-invoice'>
																								<a class="cta-btns invoice" href="JavaScript:void(0)"
																									onClick={() => history.push({
																										pathname: "/invoice",
																										state: {
																											backURL: "/history", billOfSales: item.bill_of_sale_id, gatePass: item.gatepasscode, make: item.make, model: item.model,
																											buyerId: item.buyer_dealer_id, price: item.price, soldDate: formatTime(item.sold_date_tz), VinNo: item.vin_no,
																											inventoryNo: item.carid, year: item.year, buyertax: item.buyer_tax_id, license: item.buyer_license,
																											/*  achDate: item.ach_date, */
																											selectedValues: item,
																											achDate: item.ach_date_tz == "" || item.ach_date_tz == undefined || item.ach_date_tz == null ? "" : formatTime(item.ach_date_tz)
																										}
																									})}>Invoice</a>
																							</div>


																							<div class="autocheck">
																								<img src={carcheck} alt="" />
																							</div>


																							{item.announcement == "null" || item.announcement == null || item.announcement == "undefined" ?
																								<p className='announcement'><span className="label">Announcement : </span>{""}</p> :
																								<p className='announcement'><span className="label">Announcement :  {item.announcement}</span></p>}
																							<p className="label">Delivery status : <span>{item.transportation_status_name}</span></p>
																							{item.ach_date == "" || item.ach_date == undefined || item.ach_date == null ? <p className="label">Date of fund : <span>Not yet</span></p> :
																								<p className="label">Date of fund : <span>{item.ach_date}</span></p>}


																							<div class="netamount">
																								<a class="redBtn"
																									onClick={() => history.push({
																										pathname: "/invoice",
																										state: {
																											backURL: "/history", billOfSales: item.bill_of_sale_id, gatePass: item.gatepasscode, year: item.year, make: item.make, model: item.model, buyerId: item.buyer_dealer_id, price: item.price, soldDate: formatTime(item.sold_date_tz), VinNo: item.vin_no, inventoryNo: item.carid, achDate: item.ach_date_tz == "" || item.ach_date_tz == undefined || item.ach_date_tz == null ? "" : formatTime(item.ach_date_tz)
																											, selectedValues: item
																										}
																									})}>Net Amount : $   {Number(item.price) - Number((item.bos_seller_fee) + Number(item.bos_car_charges) + Number(item.bos_sellerothertotalcharge) || 0 + Number(item.bos_seller_fee || 0))} </a>
																							</div>



																							<div class="vinqr">
																								<div class="carpoints">

																									<div class="gatepasspoint">
																										{item.gatepasscode === "" || item.gatepasscode === undefined || item.gatepasscode === null || item.gatepasscode === "null" ?
																											<a class="history-text-color">Gate Pass Code :  </a> :
																											<a class="history-text-color">Gate Pass Code : {item.gatepasscode} </a>
																										}
																										{item.gatepasscode === "" || item.gatepasscode === undefined || item.gatepasscode === null || item.gatepasscode === "null" ? "" :
																											<img id={`imgBarCode${index}`} src={barcode} alt="" onMouseEnter={() => document.getElementById(`showBarCodeDetails1${index}`).setAttribute("class", "showContent qrcode")} onMouseLeave={() => document.getElementById(`showBarCodeDetails1${index}`).setAttribute("class", "hideContent")} />
																										}</div>
																								</div>
																								<div id={`showBarCodeDetails1${index}`} className="hideContent " >
																									<Barcode value={item.gatepasscode} {...config} />
																								</div>
																							</div>

																							<div className="" onClick={() => redirectGatePass(item.car_id)}>
																								<button className={`${item?.gatepasscode ? "printBtn2" : "printBtn1"}`} type="button"/*  onClick={() => handleGatePassPrint(historyDetail)}  */
																								>Print</button>
																							</div>
																						</div>
																					</div>




																					<div className='col-lg-4'>
																						<div class="cars-content">
																							<h3 class="add-title">Vehicle Title : </h3>

																							<form id="msform">
																								<ul id="progressbar">
																									<li className={item.vehicle_title_status == 1 ? "active" : ""} ><div>{item.title_date1_tz}</div></li>
																									<li className={item.vehicle_title_status == 2 ? "active" : ""} >{item.title_date2_tz}</li>
																									{item.vehicle_title_status !== 3 ?
																										<li className={item.vehicle_title_status == 3 ? "active" : ""} >{item.estimate_title_date_tz}</li> :
																										<li className={item.vehicle_title_status == 3 ? "active" : ""} >{item.title_date3_tz}</li>}
																								</ul>
																							</form>

																							<div class="col-md-12 text-center mb-5 paybtns">
																								<a class="redBtn carHistory" onClick={() => { carhistory(item) }} >Car History</a>
																							</div>
																						</div>
																						{item.gatepass_id == "" || item.gatepass_id == null ? "" :
																							<div className='add-sec'>
																								<h3 class="add-title mb-2">Delivery Information</h3>

																								<div class="tbox m-0 mb-4">
																									<input type="text" class="form-control" id="FirstName" defaultValue={item.first_name}
																										onChange={(e) => setFirstName(e.target.value)} disabled={item.car_delivery_info_id !== null} />
																									<label for="FirstName" className="input-has-value required" >First Name</label>
																									{item.car_delivery_info_id !== null ? "" :
																										<p className="form-input-error discontent" id={`firstnameerror${index}`}></p>
																									}
																								</div>

																								<div class="tbox m-0 mb-4">
																									<input type="text" class="form-control" id="LastName" defaultValue={item.last_name}
																										onChange={(e) => setLastName(e.target.value)} disabled={item.car_delivery_info_id !== null} />
																									<label for="LastName" className="input-has-value required" >Last Name</label>
																									{item.car_delivery_info_id !== null ? "" :
																										<p className="form-input-error discontent" id={`lastnameerror${index}`}></p>
																									}
																								</div>
																								<div class="tbox m-0 mb-4">
																									<input type="text" class="form-control" id="DriverLic" defaultValue={item.driver_license}
																										onChange={(e) => setDriverLic(e.target.value)} disabled={item.car_delivery_info_id !== null} />
																									<label for="DriverLic" className="input-has-value required" >Driver License</label>
																									{item.car_delivery_info_id !== null ? "" :
																										<p className="form-input-error discontent" id={`driverlicerror${index}`} ></p>}

																								</div>
																								<div class="add-title mb-4 mt-0">Transportation Check

																									<span className="">
																										<input type="checkbox" className="checktrans" id={`transportcheck${index}`} value={item.transaction_check == 1 ? 0 : 1}
																											checked={item.transaction_check == 1 ? true : false}
																											disabled={item.car_delivery_info_id !== null}
																											onChange={(e) => transportationcheck(`transportcheck${index}`, item, index)} />
																									</span>
																								</div>
																								{item.transaction_check == 1 ?
																									<div class="tbox m-0 mb-4">
																										<input type="text" class="form-control" id="Transname" defaultValue={item.transportation_name}
																											onChange={(e) => setTransportationName(e.target.value)} disabled={item.car_delivery_info_id !== null} />
																										<label for="Transname" class="input-has-value required" >Transportation Name</label>
																									</div> :
																									""}
																								{item.car_delivery_info_id !== null ? "" :
																									<p className="form-input-error discontent" id={`transportationnameerror${index}`} ></p>}


																								<div class="tbox m-0 mt-3 mb-4">
																									<textarea type="text" class="form-control" id="Notes" defaultValue={item.notes}
																										onChange={(e) => setNotes(e.target.value)} disabled={item.car_delivery_info_id !== null} />
																									<label for="Notes" class="input-has-value" >Notes</label>
																								</div>
																								{item.car_delivery_info_id !== null ? "" :
																									<div className="upload-btn-wrapper uploadlic">
																										<a className="btn forcolor1">
																											<img src={upload} alt="" />
																											Upload Driver License
																										</a>

																										<input
																											type="file"
																											accept=".doc,.docx,.pdf,.jpg,.jpeg,.png"
																											onChange={(e) => getFiles(e, index)}
																											className="file-input-hidden"
																											id={`fileInput${index}`}
																										/>
																									</div>
																								}

																								<label>Driver License Doc</label>
																								<img src={process.env.PUBLIC_URL + "/images/fileDocIcon.png"} className="img-fluid imf-flfcicn" alt="" />
																								<p id={`drivershow1${index}`} className="drivershow1 adrivershow">{/* {uploadDriverLicShow} */}</p>
																								<p id={`drivershow2${index}`} className="drivershow adrivershow"><a className="adrivershow" href={item.driver_lic_doc} target="_blank">{item.driver_lic_doc?.split("_")[1]}</a></p>
																								{item.car_delivery_info_id !== null ? "" :
																									<p className="form-input-error" id={`drivershowerror${index}`} ></p>}

																								<div class="col-md-12 text-center paybtns ml-3 mt-5 ">
																									{item.car_delivery_info_id == null ?
																										<a class="redBtn carHistory" id={`add${index}`} onClick={() => getDeliveryInfo(item, index)} >Add</a> :
																										<a class="redBtn carHistory" onClick={() => carDelivery(item)} >Edit</a>}

																								</div>

																							</div>
																						}
																					</div>


																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														) :
															<p className='nodata-found'>NO DATA FOUND</p>}
													</div>
												</div>

												<div className="col-lg-12 tablePagination d-flex justify-content-center pageul">
													{/* <Pagination className=""
														totalRecords={totalRecords}
														pageLimit={pageLimit}
														pageRangeDisplayed={1}
														onChangePage={setCurrentPage}
													/> */}
													<CustomPagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} totalRecords={totalRecords} handlePages={handlePages} />

												</div>
											</div>
										</div>
									</div>
								</div>
							</div>}
					</>
				}


				{isOpen &&
					<CommonPopup
						handleClose={togglePopup}
						popupTitle={popupTitle}
						popupMsg={popupMsg}
						popupType={popupType}
						popupActionType={popupActionType}
						popupActionValue={popupActionValue}
						popupActionPath={popupActionPath}
					/>}
				{isOpenAccept && <Popup
					isClose={false}
					content={<>
						<GatePassAccept toggle={togglePopupAccept} carId={carId} buyerId={buyerId} gatepassColorChange={gatepassColorChange} />
					</>}
					handleClose={togglePopupAccept}
				/>}

				{isOpenDeliver && <Popup
					isClose={false}
					content={<>
						<DeliverInfo toggle={togglePopupDeliver} billofSaleId={billofSaleId} carId={carId} carDetail={carNew} recallDeliver={recallDeliver} />
					</>}
					handleClose={togglePopupDeliver}
				/>}

				{isOpenCarHistory && <Popup
					isClose={false}
					content={<>
						<CarHistory toggle={togglePopupCarHistory} historycarId={historycarId} />
					</>}
					handleClose={togglePopupCarHistory}
				/>}



			</main>

			<section id="playstoreBlock" class="playstoreBlock">
				<div class="container">

					<div class="row content">
						<div class="col-lg-12">
							<img src={appstore} />
							<img src={googleplay} />
						</div>
					</div>
				</div>
			</section>
			<div>
				< div class="hideContent" >
					<div id="pdfPage" style={{ "border-collapse": "collapse" }}>
						<table>
							<tr className='border-0'>



								<td class="border-0" width="100%" colspan="5">
									<div align="left">
										<h1>
											<b >Seller Details</b>
										</h1>

									</div>
									<div align="left">
										<b>Seller Name</b> - {successData?.dealer_name}

									</div>
									<div align="left">
										<b>Address</b> - {successData?.address}
									</div>

								</td>

								<td align="left" class="border-0" width="50%">
									<img src={Logo_final} ></img>

								</td>
							</tr>

						</table>
						<table>

							<thead>
								<tr>

									<td><b>Year</b> </td>
									<td><b>Make </b></td>
									<td><b>Model </b></td>
									<td><b>Vin # </b></td>
									<td><b>Inventory #</b> </td>
									<td><b>Bill of sale </b></td>
									<td><b>Gate Pass Code  </b></td>
									<td><b>Title Status </b></td>
									<td><b>Total Amount</b> </td>

								</tr>
							</thead>

							{carDetailsNew?.length > 0 ? carDetailsNew.map((item) =>
								<tr>
									<td>{item.year}</td>
									<td>{item.make}</td>
									<td>{item.model}</td>
									<td>{item.vin_no}</td>
									<td>{item.carid}</td>
									<td>{item.bill_of_sale_id}</td>
									<td>{item.gatepasscode}</td>
									<td>{item.title_status_name}</td>
									<td>{Number(item.price) - Number(getFeeDetails(item.price) + Number(item.bos_car_charges) + Number(item.bos_sellerothertotalcharges))}</td>
								</tr>) : ""}

						</table>
					</div>
				</div>
			</div>

			{
				isCommonPopupOpen && <CommonPopup
					handleClose={toggleCommonPopup}
					popupTitle={popupTitle}
					popupMsg={popupMsg}
					popupType={popupType}
					popupActionType={popupActionType}
					popupActionValue={popupActionValue}
					popupActionPath={popupActionPath}
				/>
			}


		</div >



	)
}
export default History;